<div class="account-select-overlay" (click)="onOverlayClick($event)">
  <div class="account-select__modal" role="dialog" aria-modal="true" [attr.aria-label]="'Select ' + title">

    <!-- Header -->
    <div class="account-select__header">
        <div>
            <h2 class="account-select__title">Select {{ title }}</h2>
            <p class="account-select__subtitle">{{ subtitle }}</p>
        </div>
        <button type="button" class="account-select__close" (click)="onClose()" aria-label="Close modal">
            <img src="/assets/svgs/Close.svg" width="20" height="20" aria-hidden="true" />
        </button>
    </div>
    
    <!-- Search -->
    <div class="account-select__search">
        
      <!-- <p class="account-select__search-label">Search by</p> -->
      <div class="account-select__search-row">
        <div class="account-select__search-field account-select__search-field--wide">
          <button type="button" class="account-select__search-icon-btn" (click)="onSearch()" aria-label="Search accounts">
            <img src="/assets/svgs/Search.svg" width="14" height="14" class="account-select__search-icon" aria-hidden="true" />
          </button>
          <input
            placeholder="Search for an account"
            type="text"
            class="account-select__search-input"
            [(ngModel)]="searchTypeText"
            (keyup.enter)="onSearch()"
            aria-label="Search by city or state"
          />
        </div>
      </div>
    </div>

    <!-- Account List -->
    <div class="account-select__list" aria-live="polite">
      @if (isLoading()) {
        <div class="account-select__state">
          <span class="account-select__spinner" aria-label="Loading accounts"></span>
          Loading...
        </div>
      } @else if (accounts().length === 0) {
        <div class="account-select__state">No accounts found</div>
      } @else {
        @for (unit of accounts(); track unit.uid) {
          <button
            type="button"
            class="account-select__row"
            (click)="onSelectAccount(unit)"
          >
            <div><span class="account-select__row-code ml-5">{{ unit.displayCode }}</span></div>
            <span class="account-select__row-body"> 
              <div class="account-select__row-name">{{ unit.displayName }}</div>
              <div class="account-select__row-city">{{ unit.townCity }}</div>
            </span>
          </button>
        }
      }
    </div>

    <!-- Footer: pagination + result count + cancel -->
    <div class="account-select__footer">
      <div class="account-select__pagination">
        <button
          type="button"
          class="account-select__page-link"
          (click)="onGoToPage(currentPage() - 1)"
          [disabled]="!hasPrevious()"
        >
          <span class="account-select__page-chevron account-select__page-chevron--prev" aria-hidden="true"></span>
          Previous
        </button>

        @for (token of pageTokens(); track $index) {
          @if (token === '...') {
            <span class="account-select__ellipsis">...</span>
          } @else {
            <button
              type="button"
              class="account-select__page-number"
              [class.account-select__page-number--active]="token - 1 === currentPage()"
              (click)="onGoToPage(+token - 1)"
            >{{ token }}</button>
          }
        }

        <button
          type="button"
          class="account-select__page-link"
          (click)="onGoToPage(currentPage() + 1)"
          [disabled]="!hasNext()"
        >
          Next
          <span class="account-select__page-chevron account-select__page-chevron--next" aria-hidden="true"></span>
        </button>
      </div>

      <div class="account-select__footer-row">
        <!-- <p class="account-select__results">{{ startItem() }}–{{ endItem() }} of {{ totalResults() }} Results</p> -->
        <button type="button" class="account-select__cancel-btn" (click)="onClose()">Cancel
            <span><img src="/assets/svgs/Close.svg" width="16" height="16" aria-hidden="true" /></span>
        </button>
      </div>
    </div>

  </div>
</div>
